// OrderHistory.js
import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const OrderHistory = () => {
  const { user } = useContext(AuthContext);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) return;
    const fetchOrders = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/orders/user-orders`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message);
        setOrders(data);
      } catch (err) {
        setError("Error al cargar los pedidos.");
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [user]);

  if (!user) return <p className="text-center mt-12">⚠️ Debes iniciar sesión para ver tus pedidos.</p>;

  return (
    <div className="min-h-screen bg-gray-100 p-6 flex flex-col items-center">
      <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-3xl">
        <h2 className="text-3xl font-bold text-gray-800 text-center">📦 Historial de Pedidos</h2>
        {loading ? (
          <p className="text-center text-gray-500 mt-4">Cargando pedidos...</p>
        ) : error ? (
          <p className="text-center text-red-500">{error}</p>
        ) : orders.length === 0 ? (
          <p className="text-center text-gray-500 mt-4">No tienes pedidos realizados. 🛍️</p>
        ) : (
          <ul className="mt-6 space-y-6">
            {orders.map((order) => (
              <li key={order._id} className="border border-gray-300 rounded-lg p-6 shadow-md bg-gray-50">
                <h3 className="text-xl font-semibold text-gray-800">Pedido #{order._id.slice(-6)}</h3>
                <p className="text-gray-500">📅 Fecha: {new Date(order.createdAt).toLocaleDateString()}</p>
                <p className="text-gray-600 font-medium">🛒 Productos:</p>
                <ul className="list-disc pl-6">
                  {order.items.map((item) => (
                    <li key={item.id} className="text-gray-700">
                      {item.name} - {item.quantity}x (${item.price})
                    </li>
                  ))}
                </ul>
                <p className="font-bold text-gray-800 mt-2">💰 Total: ${order.total}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default OrderHistory;
